import { render } from "./InfoPage.vue?vue&type=template&id=1bbb13e6&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=1bbb13e6&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbb13e6"]])

export default __exports__